import {ErrorHandler, Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class CovErrorHandler implements ErrorHandler {
  constructor() {}

  handleError(error: unknown): void {
    console.error('Unhandled error:', error);
  }
}
